import React, { useEffect, useState } from "react";
import AdminDashboardLayout from "../layout/AdminDashboardLayout";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem
} from "@mui/material";
import { getAdminList, createAdmin } from "../../../services/adminService";

export default function AdminDashboardAdmins() {
  const [admins, setAdmins] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [form, setForm] = useState({ username: '', email: '', password: '', role: '' });

  useEffect(() => {
    async function fetchAdmins() {
      try {
        const data = await getAdminList();
        setAdmins(data);
      } catch (err) {
        // handle error if needed
      }
    }
    fetchAdmins();
  }, []);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);
  const handleFormChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await createAdmin(form);
      handleDialogClose();
      const data = await getAdminList();
      setAdmins(data);
    } catch (err) {
      handleDialogClose();
    }
  };

  return (
    <AdminDashboardLayout>
      <Box sx={{ px: 4, pt: 4, pb: 8, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            boxShadow: 4,
            overflow: "hidden"
          }}
        >
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              {/* Full-width Title Row */}
              <TableRow>
                <TableCell colSpan={100} sx={{ bgcolor: "#000", p: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        letterSpacing: 1.2,
                        color: "#fff",
                        textTransform: "uppercase"
                      }}
                    >
                      Admin Users
                    </Typography>
                    <AddCircleOutlineIcon
                      onClick={handleDialogOpen}
                      sx={{
                        color: "#fff",
                        fontSize: 28,
                        cursor: "pointer",
                        "&:hover": { color: "#bbb" }
                      }}
                    />
                  </Box>
                </TableCell>
              </TableRow>

              {/* Table Column Headers */}
              <TableRow sx={{ bgcolor: "#111" }}>
                <TableCell sx={{ color: "#fff", fontWeight: 700, textTransform: "uppercase", fontSize: "12px" }}>
                  Username
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 700, textTransform: "uppercase", fontSize: "12px" }}>
                  Email
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 700, textTransform: "uppercase", fontSize: "12px" }}>
                  Roles
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 700, textTransform: "uppercase", fontSize: "12px" }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {admins && admins.length > 0 ? (
                admins.map((admin, idx) => (
                  <TableRow
                    key={admin._id || idx}
                    sx={{
                      backgroundColor: "#fff",
                      "&:hover": {
                        backgroundColor: "#f0f0f0"
                      },
                      transition: "0.2s"
                    }}
                  >
                    <TableCell sx={{ color: "#000" }}>{admin.username || admin.name || "-"}</TableCell>
                    <TableCell sx={{ color: "#000" }}>{admin.email || "-"}</TableCell>
                    <TableCell sx={{ color: "#000" }}>
                      {Array.isArray(admin.roles)
                        ? admin.roles.join(", ")
                        : admin.roles || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#000" }}>
                      {admin.isActive ? (
                        <FiberManualRecordIcon
                          sx={{ color: "green", fontSize: 16, verticalAlign: "middle" }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ color: "#999", backgroundColor: "#fff" }}>
                    No admin users found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Add Admin Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700, textTransform: "uppercase" }}>
          Add Admin User
        </DialogTitle>
        <DialogContent sx={{ bgcolor: "#f9f9f9" }}>
          <Box
            component="form"
            onSubmit={handleFormSubmit}
            sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}
          >
            <TextField
              label="Username"
              name="username"
              value={form.username}
              onChange={handleFormChange}
              fullWidth
              required
            />
            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleFormChange}
              fullWidth
              required
              type="email"
            />
            <TextField
              label="Password"
              name="password"
              value={form.password}
              onChange={handleFormChange}
              fullWidth
              required
              type="password"
            />
            <TextField
              label="Role"
              name="role"
              value={form.role}
              onChange={handleFormChange}
              fullWidth
              required
              select
            >
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="superadmin">Super Admin</MenuItem>
            </TextField>
            <DialogActions>
              <Button onClick={handleDialogClose} color="secondary">
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Add
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </AdminDashboardLayout>
  );
}